import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useClientAuth } from "@/context/ClientAuthContext";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ClientAcceptInvite() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const { setClient } = useClientAuth();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setError("");
    if (password !== confirm) { setError("Passwords do not match"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/portal/auth/accept-invite", { token, password });
      setClient(data); navigate("/client/dashboard");
    } catch (err) { setError(formatApiError(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };

  if (!token) return <AuthShell title="Invalid link" subtitle="This activation link is missing or invalid. Please use the link from your invitation email." />;

  return (
    <AuthShell title="Activate your account" subtitle="Set a password to access your Fairview client portal.">
      <form onSubmit={submit} className="space-y-4" data-testid="client-accept-form">
        <div><Label className="text-[#D4D4D8] mb-1.5 block">Create password</Label>
          <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            data-testid="client-accept-password" placeholder="At least 6 characters" className="bg-[#121214] border-white/10 text-white h-11" /></div>
        <div><Label className="text-[#D4D4D8] mb-1.5 block">Confirm password</Label>
          <Input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
            data-testid="client-accept-confirm" placeholder="Re-enter password" className="bg-[#121214] border-white/10 text-white h-11" /></div>
        {error && <p className="text-sm text-red-400" data-testid="client-accept-error">{error}</p>}
        <Button type="submit" disabled={loading} data-testid="client-accept-submit"
          className="w-full fv-gold-gradient text-[#0A0A0B] font-semibold h-11 rounded-lg hover:opacity-90">
          {loading ? "Activating…" : "Activate & sign in"}</Button>
      </form>
    </AuthShell>
  );
}
